var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('img',{attrs:{"src":_vm.data.media_details.sizes.full.source_url}}):_c('img',{attrs:{"src":"https://www.wearlight.com/api/wp-content/uploads/2021/05/product-sample.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }